module.exports = __webpack_public_path__ + "img/quotes.27457d2c.svg";